import { GetOrgResponse } from '../api/getOrg';
import { Org } from '../models/Org';

function insensitiveCaseSort(a: { name: string }, b: { name: string }): number {
  return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
}

export function transformOrg(response: GetOrgResponse | Record<string, never>): Org | undefined {
  if (!response || !('_id' in response) || !response._id) {
    return undefined;
  }

  const r = response;
  const roles = (r.roles || []).filter(role => (role as { active?: boolean }).active !== false);

  const roleIDsToPush: unknown[] = [];
  (r.memberRoles || []).forEach(memberRole => {
    (memberRole.roles || []).forEach(role => {
      roleIDsToPush.push(role.id);
    });
  });

  const uniqueRoleIDs = roleIDsToPush.filter((value, index, self) => self.indexOf(value) === index);
  const unSortedRoles: typeof roles = [];

  uniqueRoleIDs.forEach(roleId => {
    roles.forEach(role => {
      if ((role as { id: { id: string } }).id?.id === (roleId as { id: string }).id) {
        unSortedRoles.push(role as (typeof roles)[number]);
      }
    });
  });

  const rolesDropdown = (unSortedRoles as { name: string; id: { id: string } }[])
    .sort(insensitiveCaseSort)
    .map(role => ({
      name: role.name,
      value: role.id.id,
    }));

  return {
    id: r._id.id,
    name: r.name,
    logo: r.logo,
    ownerId: r.owner?.id,
    imported: r.imported,
    roles: roles as Org['roles'],
    members: r.members,
    memberRoles: r.memberRoles as Org['members'],
    groups: r.groups as Org['groups'],
    churchAccountId: r.churchAccountId,
    showSearch: r.showSearch === undefined ? true : r.showSearch,
    rolesDropdown,
  };
}
